"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const debouncer = require("@tanstack/pacer/debouncer");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useDebouncer(fn, options, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().debouncer,
    ...options
  };
  const [debouncer$1] = react.useState(() => new debouncer.Debouncer(fn, mergedOptions));
  debouncer$1.fn = fn;
  debouncer$1.setOptions(mergedOptions);
  react.useEffect(() => {
    return () => {
      debouncer$1.cancel();
    };
  }, [debouncer$1]);
  const state = reactStore.useStore(debouncer$1.store, selector);
  return react.useMemo(
    () => ({
      ...debouncer$1,
      state
    }),
    // omit `store` in favor of `state`
    [debouncer$1, state]
  );
}
exports.useDebouncer = useDebouncer;
//# sourceMappingURL=useDebouncer.cjs.map
